import { CSSProperties } from "react";

/** Background of the dark v5 onboarding screens ("Onboarding BG" in Figma). */
export const ONBOARDING_BACKGROUND = "#130c2d";

/** Background of the Train Hard intro, which sits under a full-bleed photo. */
export const ONBOARDING_INTRO_BACKGROUND = "#120b1d";

/**
 * Paints the IonContent itself rather than only the page rendered inside it.
 *
 * On iOS the content rubber-bands past its own edges, and that stretched strip is
 * painted by IonContent, not by our page. Without this it shows whatever is behind,
 * which is light, against a dark onboarding screen.
 *
 * It has to be Ionic's `--background` variable, not `background-color`. IonContent
 * paints through a dedicated element in its shadow root (`#background-content`, styled
 * `background: var(--background)`) that sits in front of the host, so a background-color
 * on the host is hidden behind it. The sibling `.inner-scroll` is transparent by design
 * — don't measure that one when checking this works.
 */
export const onboardingContentStyle = {
  "--background": ONBOARDING_BACKGROUND,
} as CSSProperties;

export const onboardingIntroContentStyle = {
  "--background": ONBOARDING_INTRO_BACKGROUND,
} as CSSProperties;
